module.exports = __webpack_public_path__ + "img/pin_exchange_orange.ed0eeb1b.svg";